import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.motherTongue;

const getMotherTongue = createSelector(getData, status => values(status));

export default getMotherTongue;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getMotherTongue.js